import { MonthlyPayment } from '@applyonline/shared/types'
import { formatCurrency } from '@if/core/utils'
import { useTranslation } from 'react-i18next'

interface Props {
  plan: MonthlyPayment
  selected: boolean
  smallestPayment: boolean
  onSelect: () => void
}

const PlanCard = ({ plan, selected, smallestPayment, onSelect }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={`plan-card${selected ? ' plan-card--selected' : ''}`} onClick={onSelect}>
      <input
        className="plan-card__radio"
        type="radio"
        name="plan-term"
        value={plan.term}
        checked={selected}
        onChange={onSelect}
        aria-label={t('worksheet.plan.title', { term: plan.term })}
      />
      {smallestPayment && <span className="plan-card__badge">{t('worksheet.plan.smallestPayment')}</span>}
      <div className="plan-card__cell plan-card__cell--term">
        <span className="plan-card__value">{plan.term}</span>
        <span className="plan-card__label">{t('worksheet.plan.monthPlan')}</span>
      </div>
      <div className="plan-card__cell">
        <span className="plan-card__value">
          {t('worksheet.plan.interestRateValue', { rate: plan.effectiveRateWithoutInsurance.toFixed(2) })}
        </span>
        <span className="plan-card__label">{t('worksheet.plan.interestRate')}</span>
      </div>
      <div className="plan-card__cell plan-card__cell--payment">
        <span className="plan-card__value plan-card__value--accent">
          {formatCurrency(plan.amountWithoutInsurance)}
        </span>
        <span className="plan-card__label">{t('worksheet.plan.monthlyPayment')}</span>
      </div>
    </div>
  )
}

export default PlanCard
